import type { PictureInfoPanelAttributes } from '../../types/cms'
import { CmsButton } from '../Button'
import { MarkdownText, SlideCarousel } from 'ui-kit'
import { PictureInfoPanelContainer, FeaturesList } from './styles'
import { Container, Grid, Stack, Box } from '@mui/material'
import FormattedImage from '../FormattedImage'

const PictureInfoPanel = ({
  title,
  backgroundColour,
  info,
  images,
  listItems,
  isList,
  textColour,
  button,
}: PictureInfoPanelAttributes) => {
  const imageData = images?.data ?? []

  return (
    <PictureInfoPanelContainer
      bgColour={backgroundColour ?? '#FFF'}
      textColour={textColour ?? '#000'}
    >
      <Container maxWidth="xl">
        <Stack gap={8.5}>
          <MarkdownText>{title}</MarkdownText>
          <Grid
            container
            direction={isList ? 'row' : 'row-reverse'}
            justifyContent="space-between"
            alignItems="flex-start"
            gap={1}
          >
            <Grid item xs={12} md={5}>
              <Box style={{ whiteSpace: 'pre-wrap' }}>
                <MarkdownText>{info && info}</MarkdownText>
              </Box>
              {isList && (listItems?.length ?? 0) > 0 ? (
                <Box sx={{ mt: 5 }}>
                  {listItems?.map(({ icon, info: itemInfo }) => (
                    <FeaturesList key={itemInfo}>
                      <Box component="li">
                        <Stack direction="row" alignItems="center">
                          <img src={icon?.data?.attributes?.url} alt="tick" />
                          <MarkdownText>{itemInfo}</MarkdownText>
                        </Stack>
                      </Box>
                    </FeaturesList>
                  ))}
                </Box>
              ) : null}
            </Grid>
            <Grid item xs={12} md={6}>
              {imageData.length > 1 ? (
                <SlideCarousel
                  activeIndicatorColour="#000"
                  inactiveIndicatorColour="rgb(0, 0, 0, 1)"
                >
                  {imageData.map(image => (
                    <FormattedImage
                      image={{ data: image }}
                      key={image.id}
                      responsive
                    />
                  ))}
                </SlideCarousel>
              ) : (
                imageData.map(image => (
                  <FormattedImage
                    image={{ data: image }}
                    key={image.id}
                    responsive
                  />
                ))
              )}
            </Grid>
          </Grid>
        </Stack>
      </Container>
      {button && (
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ width: '100%' }}
        >
          <CmsButton
            href={button.link ?? ''}
            backgroundColor={button.backgroundColour}
            color={button.textColour}
            target={button.target}
            rel={button.rel}
          >
            {button.text}
          </CmsButton>
        </Stack>
      )}
    </PictureInfoPanelContainer>
  )
}

export default PictureInfoPanel
